import React, { useState } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { FormattedMessage, useIntl } from "react-intl";
import { OptionalCoupon } from "../../../../../../layout/fragments/black-coupon-alert";
import Mask from "../../../../../../components/mask";
import { unitPrice } from "../../../../../../../../utils/product";
import { Iconfont } from "../../../../../../../components/icon/iconfont";

const percent = (per) => "-" + (per || 0) + '%'

export const DiscountAlert = props => {
    useStyles(classes)
    const { show, setShow, per, couponActivity, originPrice, isEstimated, lower, selectedProduct, selectedVariant } = props
    const { couponActivitySimpleName, couponDiscount, estimatedPrice, coupons } =  selectedVariant?.couponDiscount ?
        { ...selectedProduct?.couponActivity, couponDiscount: selectedVariant?.couponDiscount } :
        selectedProduct?.couponActivity || {}
    const intl = useIntl()

    return <>
        <div className={`${classes.DiscountAlert}`}>
            <div>
                <div className={classes.Hd}>
                    <span className={classes.Content}>
                        <FormattedMessage id="promotion_details" defaultMessage={'Promotion Details'} />
                    </span>
                    <Iconfont className={classes.Icon} onClick={e => setShow(false)}>&#xe69a;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    {
                        estimatedPrice && isEstimated && <React.Fragment>
                            {/*  折后价 */}
                            <div className={classes.FinalPriceBox}>
                                <div className={classes.FinalPrice}>
                                    <div className={classes.FinalPriceTitle}>
                                        <FormattedMessage id="estimated_price" defaultMessage={'Estimated Price'} />
                                    </div>
                                    <div className={classes.FinalPriceTag}>
                                        {unitPrice(estimatedPrice)}
                                    </div>
                                </div>
                            </div>

                            {/* 折后计算 */}
                            <div className={classes.PriceCountBox}>
                                <div className={classes.PriceCountTitle}>
                                    <FormattedMessage id="buy_now_enjoy" defaultMessage={'Buy now to enjoy the following benefits'} />
                                </div>
                                <div className={classes.PriceLine}>
                                    <div className={classes.PriceType}>
                                        <FormattedMessage id="discount_price" defaultMessage={'Discount Price'} />
                                    </div>
                                    <div className={classes.OriginPrice}>
                                        <p className={classes.Discount}>{unitPrice(lower)}</p>
                                        <p className={classes.Origin}>{`(${intl.formatMessage({ id: 'original_price', defaultMessage: 'Original Price' })} ${unitPrice(originPrice)})`}</p>
                                    </div>
                                </div>
                                <div className={classes.DiscountLine}>
                                    <div className={classes.DicountMsg}>{couponActivitySimpleName}</div>
                                    <div className={classes.DicountPrice}>{"-" + unitPrice(couponDiscount)}</div>
                                </div>
                                <div className={classes.FinalLine}>
                                    <div className={classes.PriceFinal}>
                                        <span><FormattedMessage id="estimated_price" defaultMessage={'Estimated Price'} /></span>
                                        <span className={classes.PriceDisountTag}>{percent(per)}</span>
                                    </div>
                                    <div className={classes.PriceFinalCount}>{unitPrice(estimatedPrice)}</div>
                                </div>
                            </div>

                            {/* 加购按钮 */}
                            <div className={classes.AddToCartBtn}>
                                {/* <BigButton onClick={() => {
                                    if(!isDisabled){
                                        handleAddToCart?.()
                                    }
                                }} loading={carting} isDisabled={isDisabled}>
                                    <FormattedMessage id="add_to_cart" />
                                </BigButton> */}
                                <span className={classes.AddToCartTip}>
                                    <FormattedMessage id="discount_shown_estimated" defaultMessage={'Discounts shown are estimated and subject to coupon rules. Final price may vary.'} />
                                </span>
                            </div>
                        </React.Fragment>
                    }

                    {/* 优惠券列表 */}
                    {
                        coupons?.length > 0 &&
                        <div className={classes.CouponListBox}>
                            <div className={classes.CouponTitle}><FormattedMessage id="coupon" defaultMessage={'Coupon'} /></div>
                            <div className={classes.CouponList}>
                                {
                                    coupons?.map((c, index) => {
                                        return <OptionalCoupon key={c?.id} coupon={c} isBest={c?.bestCoupon && isEstimated} isPc={true} />
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        {
            show && <Mask onClick={() => setShow(false)} />
        }
    </>
}


const PriceDiscountAlert = props => {
    useStyles(classes)
    const { per, showProm, setShowProm, amount } = props

    const handleClick = () => {
        //  打开弹窗
        setShowProm(true)
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"estimated_price",
            })
        }
    }

    return <React.Fragment>
        {/*  预估折后 比例 */}
        <span className={classes.PriceDiscountBox} onClick={handleClick}>
            <span className={classes.PriceTxt}><FormattedMessage id="estimated" defaultMessage={'Estimated'} /></span>
            <span className={classes.PriceDiscount}>{unitPrice(amount)}</span>
        </span>
    </React.Fragment>
}

export default PriceDiscountAlert